const OKTA_ORIGIN = `https://myidentity.ckotech.co`;
const AUTHZ_ID = `ausqsfssawA52gL1I0h7`;
const CLIENT_ID = `0oaqsfu9g7WLdzjTy0h7`;
const DASHBOARD_ORIGIN = `https://mydashboard.ckotech.co`;
const DASHBOARD_REDIRECT_URI = `${DASHBOARD_ORIGIN}/implicit/callback`;
const ISSUER = `${OKTA_ORIGIN}/oauth2/${AUTHZ_ID}`;
const EXP = 1781104890; // Wednesday, June 10, 2026 15:21:30 GMT+0000
const SP_GROUPS = ['Dashboard.External', 'Everyone', 'Test Users'];
const USER_CLAIMS = {
    sub: '00uvd2usx9f41P6vu0h7',
    email: 'test-dashboard.sp6n7q0c@mailosaur.io',
    ver: 1,
    iss: ISSUER,
    aud: CLIENT_ID,
    iat: 1671101289,
    exp: EXP,
    jti: 'ID.bCmbVT2r9HAGAWkZ_xSYANKl6uovgSt6emRTB8BMSMM',
    amr: ['pwd'],
    idp: '00oqecjwvmt4V9i4C0h7',
    nonce: 'randomnonce',
    auth_time: 1671101280,
    at_hash: 'X4dWk-vJsu3si6T3xYN4rQ',
    spGroups: SP_GROUPS,
};
const TOKEN = {
    header: 'eyJraWQiOiJUQUY3b2k1Rml0WllGa3V3Qk5NLUx3Mm5rSFc2YVBCNklJd0ZpVXN1bFo0IiwiYWxnIjoiUlMyNTYifQ',
    body: 'jwtbody.jwtsignature',
    signature: 'jwtsignature',
};
const SCOPES = ['openid', 'email'];
const WELL_KNOWN = {
    issuer: ISSUER,
    authorizationEndpoint: `${ISSUER}/v1/authorize`,
    tokenEndpoint: `${ISSUER}/v1/token`,
    userinfoEndpoint: `${ISSUER}/v1/userinfo`,
    registrationEndpoint: `${ISSUER}/v1/clients`,
    jwksUri: `${ISSUER}/v1/keys`,
};
export const TEST_CONSTANTS_OKTA = {
    wellKnown: WELL_KNOWN,
    scopes: SCOPES,
    authOptions: {
        issuer: ISSUER,
        clientId: CLIENT_ID,
        redirectUri: DASHBOARD_REDIRECT_URI,
        postLogoutRedirectUri: DASHBOARD_REDIRECT_URI,
    },
    accessToken: {
        accessToken: `${TOKEN.header}.${TOKEN.body}.${TOKEN.signature}`,
        claims: USER_CLAIMS,
        tokenType: 'jwt',
        userinfoUrl: WELL_KNOWN.userinfoEndpoint,
        expiresAt: EXP,
        authorizeUrl: WELL_KNOWN.authorizationEndpoint,
        scopes: SCOPES,
        pendingRemove: false,
    },
    idToken: {
        idToken: `${TOKEN.header}.${TOKEN.body}.${TOKEN.signature}`,
        claims: USER_CLAIMS,
        issuer: WELL_KNOWN.issuer,
        clientId: CLIENT_ID,
        expiresAt: EXP,
        authorizeUrl: WELL_KNOWN.authorizationEndpoint,
        scopes: SCOPES,
    },
};
